import axios from "axios";
import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";

export default function AssessmentSampleWelcome() {
    let { usrData } = useParams();
    const navigate = useNavigate(); 
    const [totalQuestions, setTotalQuestions] = useState(0);  

    useEffect(()=>{
        if(usrData){
            getAssessmentDetails()
        }
    },[usrData])

    const getAssessmentDetails = async() => {
        await axios.get(`/api/getSurveyDetails?surveyData=${usrData}`)
        .then(async function (response) {
            let result = response.data;
            if(result.success){
                setTotalQuestions(result.data.questions.length)
            }
        })
    }

    const handleStart = () => {
        navigate('/assessment-sample/'+usrData)
    }

    return(       
        <>
            <div className="RgCenterAlign">
                <div className="card RgQuestionCard">
                    <Link to='/'>
                        <img src={process.env.REACT_APP_BASE_URL+"assets/img/first-feedback-logo.png"} className="logo" alt="logo" />
                    </Link>
                    <hr/>
                    <div className="card-header border-0  m-auto">
                        {/* <h1>Welcome to Survey</h1>  */}
                        <h4 className="subjectName" >Welcome to the Clearpoint 360 <br/> for <span>Subject's Name</span>. This survey consists of {totalQuestions} questions. Click next when ready.</h4>                      
                        {/* <p className='mt-2'></p> */}
                    </div> 
                    <div className="col-md-10 offset-md-1">
                        <button type="button" className="btn btn-primary w-100" onClick={handleStart}> Start &nbsp; <span className="bi bi-chevron-right"></span></button>
                    </div>                               
                </div>  
            </div>
        </>
    )
}